import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { getContentType, removeDefaultParams } from '../../Utils/helper';
import { GridWrapper } from '../StoreHomePage/BannersGrid/styled';
import TopicCard from '../TopicListing/TopicListingCards/TopicCard';
import {
  CardBox,
  CardBoxContainer,
  CardGrid,
  ViewAllTopic,
} from '../TopicListing/TopicListingCards/styled';
import { MostReadArticle, SimilarVideoTitle } from './ArticlesAndVideos/styled';
import { getSearchParams } from './common';
import { fireClickedCardEvent } from '../../Utils/useFirebase';

export default function TrendingTopics(props) {
  const { data, isStagePage } = props;
  const router = useRouter();
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });

  return (
    <GridWrapper>
      <div>
        <SimilarVideoTitle>{data?.heading}</SimilarVideoTitle>
        <MostReadArticle>{data?.subHeading}</MostReadArticle>
      </div>
      <CardGrid>
        {data?.items?.map((element, index) => {
          if (index < 5) {
            return (
              <CardBoxContainer key={`topic_${index}`}>
                <TopicCard
                  title={data?.heading}
                  data={element}
                  isStagePage={isStagePage}
                  itemIndex={index}
                  setGridCardSignal={setGridCardSignal}
                  gridCardSignal={gridCardSignal}
                  key={index}
                />
              </CardBoxContainer>
            );
          } else {
            return (
              <Link
                href={{
                  pathname: '/topics',
                  query: removeDefaultParams(router.query),
                }}
                key={index}
                legacyBehavior
              >
                <CardBox
                  onClick={(e) => {
                    e.preventDefault();
                    setTimeout(() => {
                      router.push('/topics' + getSearchParams());
                    }, [200]);
                    as = 'a';

                    setGridCardSignal({
                      index: index,
                      show: true,
                    });
                    fireClickedCardEvent(
                      data?.heading,
                      data?.description,
                      getContentType(),
                      data?.term_id,
                      data?.web_url,
                    );
                  }}
                  className={
                    gridCardSignal.index === index
                      ? 'gridcardopacity transitionClass'
                      : 'transitionClass'
                  }
                >
                  <ViewAllTopic>View all {element?.count} topics</ViewAllTopic>
                </CardBox>
              </Link>
            );
          }
        })}
      </CardGrid>
    </GridWrapper>
  );
}
